module.exports = __webpack_public_path__ + "assets/img/check-only.cea7232d.svg";